import { http } from '@/services/http';
import { toQueryParams } from '@/shared/lib/url/toQueryParams';

import type { FeedInfo } from '../types';

const group = import.meta.env.VITE_FEED_GROUP;
export type FeedFilters = { KeyCategory?: string; KeyValue?: string };

async function fetchForExtendedRange(metadata?: FeedFilters) {
  const params = toQueryParams({
    group,
    from: '60d',
    'field.Status': 'Live',
    ...metadata
  });

  const { data }: { data: FeedInfo[] } = await http.data.get(`index${params}`, {
    headers: {
      Accept: 'application/json'
    }
  });
  return data;
}

export const fetchFeedData = async (metadata?: FeedFilters): Promise<FeedInfo[]> => {
  const params = toQueryParams({
    group,
    from: '30d',
    'field.Status': 'Live',
    ...metadata
  });
  let feedInfoData: FeedInfo[];
  const { data }: { data: FeedInfo[] } = await http.data.get(`index${params}`, {
    headers: {
      Accept: 'application/json'
    }
  });
  if (data && data.length > 0) {
    feedInfoData = data;
  } else {
    feedInfoData = await fetchForExtendedRange(metadata);
  }
  return feedInfoData.map(feedInfo => {
    const transactionTime = feedInfo.transactionTime;
    return {
      ...feedInfo,
      transactionTime: transactionTime.includes('Z') ? transactionTime : `${transactionTime}Z`
    };
  });
};
